<div class="sidebar-candidate-texts"><app-loading [isLoading]="isLoading"><app-table [cols]="cols" [rows]="rows"></app-table></app-loading></div>
